export function cleanUrl() {
    let url = window.location.href;
    if (url.slice(-12) === 'unauthorized') {
        url = url.slice(0, -13);
    }
    return url;
}